import { useSelector } from 'react-redux'
import {
  connectionStatusView,
  isMultiTabView,
  loadedView,
  willReconnectInView,
  workspaceIdView,
} from '$comp/main/root.reducer'
import { t } from '$i18n'
import { useBrowserIsOnline } from '$hooks/use-browser-connection'

export function useIsAppLoaded() {
  return useSelector(loadedView)
}

export function useIsMultiTab() {
  const isMultiTab = useSelector(isMultiTabView)
  return Boolean(isMultiTab)
}

export function useConnectionStatus() {
  return useSelector(connectionStatusView)
}

export function useWillReconnectIn() {
  return useSelector(willReconnectInView) as number
}

export function useDisplayedConnectionStatus() {
  const status = useConnectionStatus()
  const browserIsOnline = useBrowserIsOnline()

  if (!browserIsOnline) return t('connectionStatus.waitingForNetwork')

  switch (status) {
    case 'connecting':
    case 'authenticating':
      return t('connectionStatus.connecting')
    case 'updating':
      return t('connectionStatus.updating')

    default:
      return null
  }
}

export function useCurrentWorkSpaceId() {
  return useSelector(workspaceIdView) as string
}
